import extractDetailedQuestionnaireData from '../../data_management/extractDetailedQuestionnaireData'
import getQuestionnaireInstancesOfQuestionnaire from '../../data_management/getQuestionnaireInstancesOfQuestionnaire'
import TransferQuestionnaireOwnershipController from '../modals/transfer_questionnaire_ownership_controller'
import getPeople from '../../data_management/async_accessors/get_people'

const QuestionnaireController = function ($routeParams, $location, $scope, initialDataInteractor, eventsService, ModalService,
                                          questionnairesInteractor, questionnaireInteractor) {
  const $ctrl = this;

  initialDataInteractor.executeWithInitializedSession(() => {
    $scope.$evalAsync(() => {
      questionnaireInteractor.loadQuestionnaire($routeParams.id, () => {
        onInit();
      });
    });
  });

  function onInit() {
    $ctrl.questionnaire = angular.copy(extractDetailedQuestionnaireData(initialDataInteractor, $routeParams[ 'id' ]));
    $ctrl.questionnaireInstances = getQuestionnaireInstancesOfQuestionnaire(initialDataInteractor, $routeParams[ 'id' ]);
    $ctrl.loaded = true;
    $scope.$digest();
  }

  $ctrl.editQuestionnaire = function () {
    return Promise.resolve().then( () => $location.path('/questionnaires/' + $ctrl.questionnaire.id + '/edit'));
  };

  $ctrl.onTabSelected = function (tabId) {
    $ctrl.display = tabId;
  };

  $ctrl.deleteQuestionnaire = function () {
    return questionnairesInteractor.deleteQuestionnaire($ctrl.questionnaire.id)
      .then(() => $scope.$apply(() => $location.path('/questionnaires')));
  };

  $ctrl.transferOwnership = function () {
    return getPeople(initialDataInteractor).then(people => {
      people.sort((a, b) => {
        if (a.name > b.name) return 1;
        if (a.name < b.name) return -1;
        return 0;
      });

      ModalService.showModal({
        templateUrl: 'modals/transfer_questionnaire_ownership.html',
        controllerAs: '$ctrl',
        controller: TransferQuestionnaireOwnershipController,
        inputs: {
          questionnaire: $ctrl.questionnaire,
          transferOwnership: person => {
            return questionnaireInteractor.transferOwnership($ctrl.questionnaire, person)
              .then(() => {
                      eventsService.publishSystemMessage('Questionnaire given to ' + person.name);
                      $scope.$apply(() => $location.path('questionnaires'));
                    },
                    () => eventsService.publishSystemError('Failed to give questionnaire to ' + person.name));
          },
          people: people
        }
      })
    })

  }
};

export default {
  name: 'QuestionnaireController',
  fn: QuestionnaireController
};